if (!customElements.get('linea-prelaunch-form')) {
  customElements.define(
    'linea-prelaunch-form',
    class LineaPrelaunchForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.errorEl = this.querySelector('[data-linea-error]');
        this.formWrap = this.querySelector('[data-linea-form-wrap]');
        this.successWrap = this.querySelector('[data-linea-success]');

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }
      }

      isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
        this.input?.setAttribute('aria-invalid', 'true');
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.input?.setAttribute('aria-invalid', 'false');
      }

      onSubmit(event) {
        const value = (this.input?.value || '').trim();

        if (!value) {
          event.preventDefault();
          this.showError(this.dataset.errorEmpty || 'Please enter your email address.');
          return;
        }

        if (!this.isValidEmail(value)) {
          event.preventDefault();
          this.showError(this.dataset.errorInvalid || 'Please enter a valid email address.');
          return;
        }

        this.clearError();

        // Progressive enhancement: submit via fetch so the success state can
        // show instantly without leaving the page. If fetch fails for any
        // reason, fall back to a normal full-page submit — the server-side
        // form.posted_successfully? check in the section still renders the
        // success state correctly on that reload.
        event.preventDefault();
        const formData = new FormData(this.form);

        fetch(this.form.action, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) throw new Error('Request failed');
            if (this.formWrap) this.formWrap.hidden = true;
            if (this.successWrap) this.successWrap.hidden = false;
          })
          .catch(() => {
            this.form.submit();
          });
      }
    }
  );
}

if (!customElements.get('linea-countdown')) {
  customElements.define(
    'linea-countdown',
    class LineaCountdown extends HTMLElement {
      connectedCallback() {
        this.targetTime = Date.parse(this.dataset.target);
        this.daysEl = this.querySelector('[data-countdown-days]');
        this.hoursEl = this.querySelector('[data-countdown-hours]');
        this.minutesEl = this.querySelector('[data-countdown-minutes]');
        this.secondsEl = this.querySelector('[data-countdown-seconds]');

        if (!this.targetTime || Number.isNaN(this.targetTime)) {
          this.hidden = true;
          return;
        }

        this.tick();
        this.interval = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      tick() {
        const diff = Math.max(0, this.targetTime - Date.now());
        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

        if (diff <= 0 && this.interval) {
          clearInterval(this.interval);
        }
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-linea-scroll-target]');
  if (!link) return;

  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
});
